export enum ViewShareLinkFormFields {
  LinkName = 'linkName',
}
